export interface ProyectoColaboradorDTO {
    iddecinvproyectocolaboradores: number;
    iddecinvproyecto?: number | null;
    tipocolaborador: number;
    cedula: string;
    nombre: string;
    email: string;
    iddecinvrolinvestigador: number;
    ultimocambio?: Date | null;
    institucion: string;
    idunidad?: number | null;
    escolabproyecto?: number | null;
    enescalafon: string;
    considerarestimulo: string;
    estimulo: string;
    fechacheckescalafon?: Date | null;
    titulosubproyecto: string;
    fechaingresoproyecto?: Date | null;
    fechasalidaproyecto?: Date | null;
}

export function GetVoidProyectoColaborador(): ProyectoColaboradorDTO {
  return {
    iddecinvproyectocolaboradores: 0,
    iddecinvproyecto: 0,
    tipocolaborador: 0,
    cedula: '',
    nombre: '',
    email: '',
    iddecinvrolinvestigador: 0,
    ultimocambio: new Date,
    institucion: '',
    idunidad: 0,
    escolabproyecto: 1,
    enescalafon: '',
    considerarestimulo: '',
    estimulo: '',
    fechacheckescalafon: new Date,
    titulosubproyecto: '',
    fechaingresoproyecto: new Date,
    fechasalidaproyecto: new Date,
  };
}